import axiosInstance from "../axiosInstance";

export const fetchStates = async () => {
    try {
        const response = await axiosInstance.get("/location/states");

        if(response.status === 200){
            return response.data;
        }
        else{
            return [];
        }
    } catch (error) {
        console.error("Error fetching states:", error);
        return []; // Return empty array on failure
    }
};
